/* global $ */
import React from 'react';

import { getUrlVars, mapkv, noVal } from '../base/utils/miscutils';

import C from '../C';
import { iCan } from '../base/Roles';
import Misc from '../base/components/Misc';
import ActionMan from '../plumbing/ActionMan';
import DataStore from '../base/plumbing/DataStore';
import PropControl from '../base/components/PropControl';
import { notifyUser } from '../base/plumbing/Messaging';

const setupFromTag = (taghtml, pageUrl) => {
	let $tag = $('<section>' + taghtml + '</section>'); // NB: add a wrapper 'cos jquery arrays quietly fail for find and sub-select.
	let $div = $tag.find('div');
	let $script = $tag.find('script');
	let src = $script.attr('src') || '';
	let scriptParams = getUrlVars(src, true);
	let setup = scriptParams;
	// size
	setup.size = $div.data('format');
	if ($div.data('mobile-format')) setup.mobileSize = $div.data('mobile-format');
	if ($div.data('format-mobile')) {
		notifyUser({ type: 'error', text: 'Bad format: data-format-mobile should be data-mobile-format', id: 'bad-mobile-format:' + taghtml, path: true });
	}
	// server
	if (src.indexOf('//as.good-loop.com/unit.js') !== -1) setup.server = 'live';
	else if (src.indexOf('//testas.good-loop.com/unit.js') !== -1) setup.server = 'test';
	// else setup.error.push('Invalid server: '+src);
	return setup;
};

const tagFromSetup = (setup) => {
	let unit = setup.server === 'test' ? '//testas.good-loop.com/unit.js?' : '//as.good-loop.com/unit.js?';
	// NB: We don't escape the values, so that weird macros can go through
	let params = mapkv(setup, (k, v) => k === 'size' || k === 'dfp' || noVal(v) || v === '' ? null : k + '=' + v);
	params = params.filter(p => !!p); // filter null
	unit += params.join('&');
	// if (setup.site) unit += 'site='+escape(setup.site)+'&';
	// if (setup.vert) unit += 'gl.vert='+setup.vert+'&';
	// if (setup.variant) unit += 'gl.variant='+setup.variant+'&';
	// if (setup.via) unit += 'gl.via='+setup.via+'&';
	// dfp last as most likely to break stuff
	if (setup.dfp) {
		unit += '&';
		if (!setup.site) {
			setup.site = '%%SITE%%';
			unit += 'site=%%SITE%%&';
		}
		unit += 'gl.url=%%PATTERN:url%%&width=%%WIDTH%%&height=%%HEIGHT%%&adunit=%%ADUNIT%%&cb=%%CACHEBUSTER%%&';
	}
	// event handlers -- set in advert or publisher for preference
	// if (setup.onclick) unit += 'gl.onclick='+escape(setup.onclick)+'&';
	// if (setup.onopen) unit += 'gl.onopen='+escape(setup.onopen)+'&';
	// if (setup.onminview) unit += 'gl.onminview='+escape(setup.onminview)+'&';
	// pop trailing ?&
	if (unit[unit.length - 1] === '?' || unit[unit.length - 1] === '&') unit = unit.substr(0, unit.length - 1);
	return `<div class='goodloopad'${setup.size && setup.size !== 'auto' ? " data-format='" + setup.size + "' data-mobile-format='" + setup.size + "'" : ''}></div>
<script src='${unit}' async></script>`;
};

function TagTestPage() {
	return (
		<div className=''>
			<h2>Tag Test Tool</h2>
			<TagTestTool />
		</div>
	);
}


function TagTestTool() {
	let path = ['location', 'params']; // ['widget','tagtest', 'tagsetup'];
	let setup = DataStore.getValue(path) || DataStore.setValue(path, { dfp: true });
	let taghtml = tagFromSetup(setup);
	DataStore.setValue(['widget', 'tagtest', 'taghtml'], taghtml, false);
	// setup.tag = taghtml;

	// allow miscellaneous parameters
	let misc = Object.keys(setup);
	const SPECIAL = ['site', 'gl.via', 'server', 'gl.vert', 'gl.variant', 'size', 'dfp'];
	misc = misc.filter(k => SPECIAL.indexOf(k) === -1);

	let mpath = ['widget', 'tagtest', 'macros'];
	let macroValues = DataStore.getValue(mpath);
	if (!macroValues) {
		macroValues = DataStore.setValue(mpath, {
			egurl: 'https://example.com/my-article',
			'%%WIDTH%%': 300,
			'%%HEIGHT%%': 250,
			// '%%SITE%%': macroValues.egurl,
			'%%ADUNIT%%': '7867sytd',
			'%%CACHEBUSTER%%': '546klda',
		});
	}
	Object.values(setup).forEach(v => {
		if (v && v[0] !== escape(v[0])) {
			if (macroValues[v] === undefined) macroValues[v] = ''; // NB dont overwrite set eg values
		}
	});

	// apply DfP macros
	let expandedTagHtml = taghtml;
	Object.keys(macroValues).forEach(mk => {
		expandedTagHtml = expandedTagHtml.replace(mk, macroValues[mk]);
	});
	expandedTagHtml = expandedTagHtml.replace('%%SITE%%', escape(macroValues.egurl));
	expandedTagHtml = expandedTagHtml.replace('%%PATTERN:url%%', escape(macroValues.egurl));
	// TODO more DfP macros

	return (
		<div>
			<p>This tool lets you setup and test Good-Loop ad-unit tags.
		Publishers can use a plain tag. DSPs will typically have to add macros to that. This page helps you setup the macros.
	See also the <a href="https://doc.good-loop.com" target="_blank">documentation site</a>.</p>
			<Misc.Col2>
				<div>
					<h2>Setup</h2>
					<h3>Your Tag</h3>
					<p>Here is the tag for use in the html editor or tag manager for your page.</p>
					<PropControl id="mytag" path={['widget', 'tagtest']}
						prop="taghtml" label="Tag" type="textarea" rows="6"
					/>
					<button type="button" className="btn btn-default btn-xs pull-right"
						onClick={() => {
							let copyElement = document.getElementById('mytag');
							copyElement.select();
							document.execCommand("copy");
						}}
					>
						copy to clipboard
					</button>

					<h3>Build your tag here</h3>

					<PropControl path={path} prop="dfp" label="DoubleClick Macros" type="checkbox" />

					<p><i>Best practice tip: Use this to pass in macro values from other systems in the ad delivery chain (e.g. the DSP or SSP).
						Otherwise leave the options below blank for flexible automatic behaviour.
				If in doubt, set site to your website.</i></p>

					<PropControl path={path} prop="size" label="Ad Size" type="select"
						options={['auto'].concat(Object.keys(C.ADSIZEINFO))}
						labels={Object.assign({ auto: 'automatic (preferred)' }, C.ADSIZEINFO)}
					/>

					<PropControl path={path} prop="gl.variant" label="Variant" />

					<PropControl path={path} prop="server" label="Server" type="select"
						options={['live', 'test']}
						error={setup.server && setup.server !== 'live' ? 'Only use this tag for testing' : null}
					/>

					<PropControl path={path} prop="site" label="Site (publisher domain)" />

					<PropControl path={path} prop="gl.via" label="via (DSP agency)" />

					<PropControl path={path} prop="gl.vert" label="Advert ID" type="text" />

					<p>Coming soon: mobile leaderboard (320x50). Other sizes? Please ask.</p>

					<h4>Misc Parameters</h4>
					{misc.map(m => <PropControl key={m} path={path} prop={m} label={m} />)}

					<h3>Or paste tag in here</h3>
					<textarea className="form-control" rows="6"
						onChange={e => {
							let th = e.target.value;
							let sft = setupFromTag(th);
							DataStore.setValue(path, sft);
						}}
					/>

					<hr />
				</div>

				<div style={{ borderLeft: 'solid 2px #666', paddingLeft: '10px' }}>
					<h2>Preview</h2>

					<Preview expandedTagHtml={expandedTagHtml} />

					<AdInternals />

				</div>
			</Misc.Col2>
		</div>);
}

/**
 * TODO report on inside the advert's goodloop object -- but how to do that?
 * 
 */
function AdInternals() {
	// let gl = window.goodloop || {};
	// let pub = gl.pub || {};
	// let ad = (gl.onlySlot && gl.onlySlot.vert) || {};
	return null;
	// 	<div><h3>Event trackers</h3>
	// 	<h4>From the advert</h4>
	// 	{ad.advanced?
	// 		Object.keys(ad.advanced).map(onx => <div key={onx}>{onx}: {ad.advanced[onx]}</div>)
	// 		: "None"}

	// 	<h4>From the publisher or tag</h4>
	// 	{ad.advanced?
	// 		Object.keys(pub.advanced).map(onx => <div key={onx}>{onx}: {pub.advanced[onx]}</div>)
	// 		: "None"}
	// </div>
}

//<PropControl path={mpath} prop="egurl" label="Example url" placeholder="https://example.com/my-article" />
//
//<h4>Example Macro Values</h4>
//<p>In practice systems like DoubleClick should replace their macros with valid values.
//	For testing, this tool allows you to hand set example values.</p>
//{ /* TODO DfP values */
///	Object.keys(macroValues).map(
//m => Object.values(setup).indexOf(m)!==-1? <PropControl key={m} path={mpath} prop={m} label={m} /> : null
// 	)
// }
// {yessy(macroValues)? null : "No macros found in tag (that's OK for direct tags)"}
/* <h4>Example Macro-expanded tag - <i>for debug only</i></h4>
<pre><code>
	{expandedTagHtml}
</code></pre> */


function Preview({ expandedTagHtml }) {
	return (
		<div>
			<h3>How it might look</h3>
			<p>Here&#39;s that tag where any macros have been replaced with example values.
				Note: This preview is in a restricted iframe, so it will click-through rather than expand.
				Live adverts will expand to use a lightbox when they can, as that is the best user experience.
			</p>
			<iframe title="example preview" srcDoc={expandedTagHtml} style={{ width: '100%', minWidth: '300px', height: '260px' }} />
		</div>
	);
	// TODO an expanding one <Misc.RawHtml html={expandedTagHtml} />
}

export default TagTestPage;
